import { str } from 'envalid';
export const nodeEnvSpec = str({
    choices: ['development', 'production', 'test'],
    default: 'development',
});
export const appEnvSpec = str({
    choices: ['', 'local', 'development', 'staging', 'production', 'test'],
    default: '',
});
